import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setBookingData } from "../../../../redux/actions/dbactions/pateints";

const NewCalender = ({
  show,
  onHide,
  selectedID,
  selectedProID,
  dispatch,
  userName,
}) => {
  const { exploreList } = useSelector((state) => state.exploreReducer);
  const explorelist = exploreList.usr?.rec || [];
  const filterList = explorelist.filter((item) => item.svcf_id === selectedID);

  const calender = filterList[0]?.calendar || [];
  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [datebook, setDatebook] = useState(null);
  const history = useHistory();

  const handledateinput = (e) => {
    setDatebook(e.target.value);
    setIsDisabled(false);
  };
  const handleClick = async (calValue, label) => {
    const data = {
      ord_svc_date: datebook,
      ord_svc_time: label,
    };
    setSelectedColor(calValue, label);

    await dispatch(setBookingData(data));
    setIsDisabled(false);
  };
  // Reset selectedColor when selectedID changes
  useEffect(() => {
    setSelectedColor(null);
  }, [selectedID]);

  const intervalsArray = [
    { ID: "svc_cal_01", label: "00:00 to 01:00" },
    { ID: "svc_cal_02", label: "01:00 to 02:00" },
    { ID: "svc_cal_03", label: "02:00 to 03:00" },
    { ID: "svc_cal_04", label: "03:00 to 04:00" },
    { ID: "svc_cal_05", label: "04:00 to 05:00" },
    { ID: "svc_cal_06", label: "05:00 to 06:00" },
    { ID: "svc_cal_07", label: "06:00 to 07:00" },
    { ID: "svc_cal_08", label: "07:00 to 08:00" },
    { ID: "svc_cal_09", label: "08:00 to 09:00" },
    { ID: "svc_cal_10", label: "09:00 to 10:00" },
    { ID: "svc_cal_11", label: "10:00 to 11:00" },
    { ID: "svc_cal_12", label: "11:00 to 12:00" },
    { ID: "svc_cal_13", label: "12:00 to 13:00" },
    { ID: "svc_cal_14", label: "13:00 to 14:00" },
    { ID: "svc_cal_15", label: "14:00 to 15:00" },
    { ID: "svc_cal_16", label: "15:00 to 16:00" },
    { ID: "svc_cal_17", label: "16:00 to 17:00" },
    { ID: "svc_cal_18", label: "17:00 to 18:00" },
    { ID: "svc_cal_19", label: "18:00 to 19:00" },
    { ID: "svc_cal_20", label: "19:00 to 20:00" },
    { ID: "svc_cal_21", label: "20:00 to 21:00" },
    { ID: "svc_cal_22", label: "21:00 to 22:00" },
    { ID: "svc_cal_23", label: "22:00 to 23:00" },
    { ID: "svc_cal_24", label: "23:00 to 24:00" },
  ];
  const labelMapping = {};
  intervalsArray.forEach((item) => {
    labelMapping[item.ID] = item.label;
  });

  const ClosePop = () => {
    setSelectedColor(null);
    setDatebook(null);
    setIsDisabled(true);
    onHide();
  };
  const bookInfo = () => {
    history.push({
      pathname: `/dashboard/order/addorder/services/${selectedID}`,
      state: { svcf_user_profile_id: selectedProID },
    });
    setIsDisabled(true);
  };
  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];
  return (
    <Modal
      className="edit_modal profile"
      show={show}
      onHide={ClosePop}
      centered
    >
      <Modal.Header closeButton>
        <Row>
          <div>
            <p className="text-center">Schedule for {`${userName}`} [</p>
          </div>
        </Row>
        <Row>
          <p className="text-center">Mon - Fri 7:00 AM - 5:00 PM Zim time]</p>
        </Row>
      </Modal.Header>

      <Modal.Body>
        <input
          type="date"
          className="form-control mb-3"
          style={{ cursor: "pointer" }}
          value={datebook}
          onChange={(e) => handledateinput(e)}
          min={today}
        />
        {calender.length > 0 ? (
          <div className="hoverSlect !grid-cols-2 sm:!grid-cols-3">
            {calender.map((item) =>
              item.cal_value === "Y" ? (
                <button
                  key={item.cal_time}
                  className={
                    selectedColor === item.cal_time ? "selectedActive" : ""
                  }
                  onClick={() =>
                    handleClick(item.cal_time, labelMapping[item.cal_time])
                  }
                  disabled={isDisabled}
                >
                  {labelMapping[item.cal_time]}
                </button>
              ) : null
            )}
          </div>
        ) : (
          <p className="text-center">No Slots Available</p>
        )}

        <Row>
          <Col>
            {calender.length > 0 ? (
              <div className="mini_edit justify-end">
                <Button
                  className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                  variant="secondary"
                  onClick={ClosePop}
                >
                  Cancel
                </Button>

                <Button
                  className={`w-full !rounded-md !bg-primary-blue h-[43px] !max-w-28 !border-b-color text-white !text-sm ${
                    isDisabled ? "opacity-75" : "opacity-100"
                  }`}
                  variant="primary"
                  type="submit"
                  onClick={bookInfo}
                  disabled={isDisabled}
                >
                  Services
                </Button>

                {/* <Button variant="primary" type="submit">
                  Book Appoinment
                </Button> */}
              </div>
            ) : null}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export { NewCalender };
